import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { IAccountDomainService } from '../../account';
import { IDocMetaDomainService } from '../../doc-meta';
import { IUserInfoDomainService } from '../../user-info';
import { DOCUMENT_TYPE_MAP } from '@tencent/ark-model';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
import { getQuery } from '@tencent/ark-utils/lib/location';
import { LikeEntity } from '../entity/like';
var LikeDomainService = /** @class */ (function () {
    function LikeDomainService(docMetaDomain, userInfoDomain, accountDomainService) {
        var _a;
        this.docMetaDomain = docMetaDomain;
        this.userInfoDomain = userInfoDomain;
        this.accountDomainService = accountDomainService;
        this.likeEntity = new LikeEntity(docMetaDomain, userInfoDomain, accountDomainService);
        if (window.basicClientVars) {
            this.likeEntity.initWithBasicClientVars(window.basicClientVars);
        }
        else {
            var _b = (_a = location.pathname.split('/')) !== null && _a !== void 0 ? _a : [], docType = _b[1], docId = _b[2];
            if (DOCUMENT_TYPE_MAP[docType] !== undefined && docId) {
                var requestParam = {
                    docId: docId,
                    u: getQuery('u'),
                };
                this.init(requestParam);
            }
        }
    }
    LikeDomainService.prototype.init = function (requestParam) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.docMetaDomain.init(requestParam),
                            this.userInfoDomain.init(requestParam),
                        ])];
                    case 1:
                        _a.sent();
                        this.likeEntity.init({
                            fileId: this.docMetaDomain.docMetaEntity.padInfo.padId,
                            ownerId: this.docMetaDomain.docMetaEntity.ownerInfo.ownerId,
                            tinyId: this.userInfoDomain.userInfoAggregate.userInfo.tinyid,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], LikeDomainService.prototype, "init", null);
    LikeDomainService = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, IUserInfoDomainService),
        __param(2, IAccountDomainService),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], LikeDomainService);
    return LikeDomainService;
}());
export { LikeDomainService };
